import { render } from "./ButtonParseTag.vue?vue&type=template&id=9df154fc"
import script from "./ButtonParseTag.vue?vue&type=script&lang=js"
export * from "./ButtonParseTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__